/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { correctPosition } from "cms/common/utils/correct-position";
import { itemWithGuid } from "cms/common/utils/item-with-guid";
import { cloneObjectsArray } from "utils/array";
import { isArrayNotEmpty } from "utils/empty-exists";
import { Logger } from "cms/utils/log/logger";

/**
 * @template T
 * @param {T[]} items
 * @param {Readonly<T>} defaultItem
 * @param {(items: T[]) => void} save
 */
export function useListControls (items, defaultItem, save) {
    const addNewItem = () => {
        const nextItems = cloneObjectsArray(items);
        const newItem = itemWithGuid(defaultItem);
        nextItems.push(newItem);
        updateItems(nextItems);
    };

    /**
     * @param {number} currentIndex 
     */
    const addNewItemBelow = (currentIndex) => {
        const nextItems = cloneObjectsArray(items);
        const newItem = itemWithGuid(defaultItem);
        const next = currentIndex + 1;
        nextItems.splice(next, 0, newItem);
        updateItems(nextItems);
    };

    /**
     * @param {T[]} nextItems 
     */
    const updateItems = (nextItems) => {
        correctPosition(nextItems);
        save(nextItems);
    };

    /**
     * @param {number} index 
     */
    const removeItem = (index) => {
        const nextItems = cloneObjectsArray(items);
        if (isArrayNotEmpty(nextItems)) {
            nextItems.splice(index, 1);
            updateItems(nextItems);
        } else {
            Logger.error(`nothing to remove at ${index}, array not found`);
        }
    };

    return {
        addNewItem,
        addNewItemBelow,
        updateItems,
        removeItem
    };
}
